import { readConfigEntry, saveConfigEntry } from "../../../lib/offline/db";
import type { OfflineConfigResource } from "./catalog";

export const shouldFetchResource = async (
  resource: OfflineConfigResource,
  ttlMs: number | null | undefined,
): Promise<boolean> => {
  const existing = await readConfigEntry(resource.key);
  if (!existing) {
    return true;
  }
  if (!ttlMs) {
    return false;
  }
  if (!existing.expiresAt) {
    return true;
  }
  return existing.expiresAt <= Date.now();
};

export const fetchResource = async (
  resource: OfflineConfigResource,
  ttlMs: number | null | undefined,
): Promise<void> => {
  try {
    const data = await resource.fetch();
    if (resource.handlesPersistence) {
      return;
    }
    const now = Date.now();
    await saveConfigEntry({
      type: resource.key,
      data,
      updatedAt: now,
      expiresAt: ttlMs ? now + ttlMs : null,
    });
  } catch (error) {
    console.warn(`Offline resource fetch failed for ${resource.key}`, error);
  }
};
